// this is used to sanitize a number field input
// in the event that the value needs to be used for maths
export function parseCurrencyToFloat(currency) {
  if (typeof currency === "number") return currency;
  if (typeof currency !== "string" || currency === "") return null;
  const sanitizedCurrency = currency.replace(/[^\d.-]/g, "");
  return parseFloat(sanitizedCurrency);
}
